import { StyledLink } from "@evg-ui/lib/components/styles";
import { MetadataItem, MetadataSection } from "components/MetadataCard";
import { Version } from "pages/version/Metadata/types";

interface LinksSectionProps {
  version: Version;
}

export const LinksSection: React.FC<LinksSectionProps> = ({ version }) => {
  const { externalLinksForMetadata } = version;

  return (
    <MetadataSection title="External Links">
      {externalLinksForMetadata?.map(({ displayName, url }) => (
        <MetadataItem key={displayName}>
          <StyledLink data-testid="external-link" href={url}>
            {displayName}
          </StyledLink>
        </MetadataItem>
      ))}
    </MetadataSection>
  );
};
